import styled from 'styled-components';
import { spaceOptions } from './utils';

export const ImageCover = styled.div`
  background-image: url('${props => props.background}');
  width: 100%;
  height: ${props => (props.height ? props.height : '120px')};
  background-size: cover;
  ${spaceOptions}
`;
